import React from 'react';
import clsx from 'clsx';

import css from './RadioGroup.module.scss';

interface Props {
    position?: 'left' | 'center' | 'right';
    children: React.ReactNode;
}

const RadioGroup: React.FC<Props> = ({ children, position = 'left' }) => (
    <div className={clsx(css.radioGroup, position && css[position])}>{children}</div>
);

export default React.memo(RadioGroup);
